import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './full-image-video.scss.js';
import { AlignmentTypes } from './types.js';

class FullImageVideo extends s {
    constructor() {
        super();
        this.isPriority = false;
        this.isWithAlert = false;
        this._isMobile = false;
        this.bodyContainer = null;
        this.componentContainer = null;
        this.ctaContainer = null;
        this.heroHeight = 0;
        this.heroMinHeight = 0;
        this.screenWidth = 0;
        this.titleContainer = null;
        this.videoContainer = null;
        this.videoTumbnail = null;
        this.firstUpdated = () => {
            this.getScreenWidth();
            this.setMobile();
            this.getMainElements();
            this.getMinHeight(this.screenWidth);
            this.getHeroHeight();
            this.setHeroHeight();
            this.setDistribution();
            this.handleCtaStyles();
            this.updateScreenWidth();
        };
        this.updateScreenWidthHandler = this.updateScreenWidth.bind(this);
    }
    getScreenWidth() {
        this.screenWidth = document.documentElement.clientWidth;
    }
    changeLightToDark(element) {
        if (!element)
            return;
        const shouldBeDark = this._isMobile;
        const styleClassMap = {
            'style-light': 'style-dark',
            'style-outlined-light': 'style-outlined-dark',
        };
        Object.entries(styleClassMap).forEach(([lightClass, darkClass]) => {
            if (shouldBeDark && element.classList.contains(lightClass)) {
                element.classList.replace(lightClass, darkClass);
            }
            else if (!shouldBeDark && element.classList.contains(darkClass)) {
                element.classList.replace(darkClass, lightClass);
            }
        });
    }
    setMobile() {
        this._isMobile = window.matchMedia('(max-width: 1023px)').matches;
    }
    getMainElements() {
        this.videoContainer = this.shadowRoot.querySelector('.video-container');
        this.videoTumbnail = this.shadowRoot.querySelector('.video-thumbnail');
        this.titleContainer = this.shadowRoot.querySelector('.title-container');
        this.bodyContainer = this.shadowRoot.querySelector('.body-container');
        this.ctaContainer = this.shadowRoot.querySelector('.cta-container');
        this.componentContainer =
            this.shadowRoot.querySelector('.full-image-video');
    }
    getMinHeight(screenWidth) {
        if (screenWidth < 768) {
            this.heroMinHeight = screenWidth;
        }
        else if (screenWidth >= 768 && screenWidth < 1024) {
            this.heroMinHeight = (9 / 16) * screenWidth;
        }
        else {
            this.heroMinHeight = (9 / 21) * screenWidth;
        }
        if (!this.videoContainer) {
            return;
        }
        this.videoContainer.style.height = `${this.heroMinHeight}px`;
    }
    getHeroHeight() {
        if (!this.videoContainer ||
            !this.titleContainer ||
            !this.bodyContainer ||
            !this.ctaContainer) {
            return;
        }
        if (this.screenWidth <= 768) {
            const _isMobileSquare = this.titleContainer.offsetHeight <=
                0.33 * this.videoContainer.offsetHeight;
            if (_isMobileSquare) {
                this.heroHeight = this.heroMinHeight;
            }
            else {
                this.heroHeight =
                    0.66 * this.videoContainer.offsetHeight +
                        this.titleContainer.offsetHeight;
            }
        }
        else if (this.screenWidth > 768 && this.screenWidth < 1024) {
            const _isExtended = this.titleContainer.offsetHeight >
                0.33 * this.videoContainer.offsetHeight;
            if (!_isExtended) {
                this.heroHeight = this.heroMinHeight;
            }
            else {
                this.heroHeight =
                    0.66 * this.videoContainer.offsetHeight +
                        this.titleContainer.offsetHeight;
            }
        }
        else {
            const contentHeight = this.titleContainer.offsetHeight +
                this.bodyContainer.offsetHeight +
                this.ctaContainer.offsetHeight;
            if (contentHeight <= this.videoContainer.offsetHeight) {
                this.heroHeight = this.heroMinHeight;
            }
            else {
                this.heroHeight = contentHeight;
            }
        }
    }
    setHeroHeight() {
        if (!this.videoContainer ||
            !this.componentContainer ||
            !this.videoTumbnail ||
            !this.bodyContainer ||
            !this.ctaContainer) {
            return;
        }
        if (this._isMobile) {
            this.videoContainer.style.height = `${this.heroHeight}px`;
            this.videoTumbnail.style.height = `${this.heroHeight}px`;
            const contentHeight = this.bodyContainer.offsetHeight + this.ctaContainer.offsetHeight;
            this.componentContainer.style.height = `${Math.max(this.videoContainer.offsetHeight, contentHeight)}px`;
        }
        else {
            this.videoContainer.style.height = `${this.heroHeight}px`;
            this.videoTumbnail.style.height = `${this.heroHeight}px`;
            this.componentContainer.style.height = `${this.heroHeight}px`;
        }
    }
    setDistribution() {
        if (!this.titleContainer ||
            !this.bodyContainer ||
            !this.ctaContainer ||
            !this.componentContainer) {
            return;
        }
        const hasButtons = this.hasCtaButtons();
        this.ctaContainer.style.display = hasButtons ? 'flex' : 'none';
        this.componentContainer.classList.toggle('has-buttons', hasButtons);
        if (this._isMobile) {
            this.titleContainer.style.bottom = `${this.ctaContainer.offsetHeight}px`;
        }
        else {
            this.bodyContainer.style.top = `${this.titleContainer.offsetHeight}px`;
            this.ctaContainer.style.top = `${this.titleContainer.offsetHeight + this.bodyContainer.offsetHeight}px`;
        }
        this.requestUpdate();
    }
    hasCtaButtons() {
        if (!this.ctaContainer)
            return false;
        return Array.from(this.ctaContainer.querySelectorAll('slot')).some(slot => slot
            .assignedElements({ flatten: true })
            .some(element => element instanceof HTMLElement &&
            (element.querySelector('button, a, generic-button-updated') ||
                element.matches('button, a, generic-button-updated'))));
    }
    handleCtaStyles() {
        var _a;
        const slots = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('slot');
        slots === null || slots === void 0 ? void 0 : slots.forEach(slot => {
            const assignedNodes = slot.assignedNodes({ flatten: true });
            assignedNodes.forEach(node => {
                if (node instanceof HTMLElement) {
                    const elements = node.querySelectorAll('button, a');
                    elements.forEach(el => {
                        if (el instanceof HTMLElement) {
                            this.changeLightToDark(el);
                        }
                    });
                }
            });
        });
        this.requestUpdate();
    }
    updateScreenWidth() {
        this.getScreenWidth();
        this.setMobile();
        this.getMainElements();
        this.getMinHeight(this.screenWidth);
        this.getHeroHeight();
        this.setHeroHeight();
        this.setDistribution();
        requestAnimationFrame(() => {
            this.handleCtaStyles();
        });
        this.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        const alertBanner = document.querySelector('alert-banner');
        if (alertBanner) {
            this.isWithAlert = true;
        }
        window.addEventListener('resize', this.updateScreenWidthHandler);
        this.updateScreenWidth();
        if (this.isPriority) {
            this.applyPriorityToImages();
        }
    }
    applyPriorityToImages() {
        setTimeout(() => {
            var _a;
            const bgImgSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="background-img"]');
            if (bgImgSlot) {
                const assignedElements = bgImgSlot.assignedElements();
                assignedElements.forEach(element => {
                    if (element.tagName === 'IMG') {
                        element.setAttribute('loading', 'eager');
                        element.setAttribute('fetchpriority', 'high');
                    }
                    const img = element.querySelector('img');
                    if (img) {
                        img.setAttribute('loading', 'eager');
                        img.setAttribute('fetchpriority', 'high');
                    }
                });
            }
        }, 0);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('resize', this.updateScreenWidthHandler);
    }
    renderVideoSlot() {
        return !this._isMobile ? $ `<slot name="video"></slot>` : null;
    }
    render() {
        return $ `<div dir="${this.rtl || isRTL() ? 'rtl' : 'ltr'}" class="full-image-video ${o({
            rtl: this.rtl || isRTL(),
            left: this.alignment === AlignmentTypes.LEFT,
            right: this.alignment === AlignmentTypes.RIGHT,
        })}"><div class="fixed-content"><div class="video-container"><div class="title-container"><slot name="heading"></slot></div><div class="video-thumbnail"><div class="gradient"></div><div class="iframe-container">${this.renderVideoSlot()}</div><slot name="background-img" class="background-img"></slot></div></div><div class="body-container"><slot name="body-text"></slot></div><div class="cta-container"><slot name="video-cta"></slot><slot name="primary-cta"></slot><slot name="secondary-cta"></slot></div></div></div>`;
    }
}
FullImageVideo.styles = css_248z;
__decorate([
    e()
], FullImageVideo.prototype, "alignment", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideo.prototype, "autoplay", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideo.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideo.prototype, "isPriority", void 0);
__decorate([
    t()
], FullImageVideo.prototype, "isWithAlert", void 0);
customElements.define('full-image-video', FullImageVideo);

export { FullImageVideo };
